import { useTranslation } from 'react-i18next'
import { ShareBreakdownTable } from './ShareBreakdownTable'
import type { BreakdownTableProps } from './TargetingTotalsTable'
import { useMeasureStats } from '../hooks/useMeasureStats'
import { useStatLabel } from '../hooks/useStatLabel'

/**
 * Measures the traffic endpoint reports, in the order they are staggered:
 * the whole audience first, then the slices that only apply to part of it.
 */
const TRAFFIC_MEASURES = ['deviceType', 'osType', 'mobileBrand', 'app']

const MEASURE_LABEL_KEYS: Record<string, string> = {
  deviceType: 'stats.deviceType',
  osType: 'stats.osType',
  mobileBrand: 'stats.mobileBrand',
  app: 'stats.app',
}

/** Delivery per device type, operating system, mobile brand and app. */
export function TrafficStatsTable({ query, range, maxHeight }: BreakdownTableProps) {
  const { t } = useTranslation()
  const statLabel = useStatLabel()
  const { groups, isLoading, error } = useMeasureStats('traffic', TRAFFIC_MEASURES, query, range)

  return (
    <ShareBreakdownTable
      groups={groups}
      groupLabel={(key) => t(MEASURE_LABEL_KEYS[key] ?? key)}
      valueLabel={statLabel('stats.impressions')}
      loading={isLoading}
      error={error}
      emptyMessage={t('stats.noTrafficStats')}
      maxHeight={maxHeight}
    />
  )
}
